import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import Home from './root.component.js';

import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.min.css"
import "./styles/main_style.css"
import "./styles/vertical_tabs.css"

function domElementGetter() {
  return document.getElementById("react-equipment-by-detail");
}

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Home,
  domElementGetter,
  suppressComponentDidCatchWarning:true,
})

export const bootstrap = [
  reactLifecycles.bootstrap,
];

export const mount = [
  reactLifecycles.mount,
];

export const unmount = [
  reactLifecycles.unmount,
];